import type { WidgetComponent } from "@viz/presentation";

const Code: WidgetComponent = ({ props }) => {
  const text = String(props.code ?? "");
  const language = String(props.language ?? "json");
  return (
    <pre className="overflow-auto rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs leading-relaxed text-slate-800">
      <code data-language={language}>{text}</code>
    </pre>
  );
};

export default Code;
